import './styles.scss';

import { Button } from '@mui/material';
import { useState } from 'react';

import ImersiveLogoDark from '../../assets/vertical-immersive-logo-dark.svg';
import Input from '../../components/input/input';

enum STEPS {
  RESET = 1,
  VERIFY_EMAIL = 2,
  NEW_PASSWORD = 3,
  FINISH = 4,
}

export default function ResetPassword() {
  const [step, setStep] = useState(STEPS.RESET);
  const [email, setEmail] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };

  const renderStep = () => {
    const STEP_VALUES = {
      [STEPS.RESET]: {
        title: 'Reset Password',
        subtitle:
          'Just enter the email address you registered with and we’ll send you a code to reset your password.',
        input: {
          label: 'Email',
          type: 'email',
          placeHolder: 'your-email@mail.com',
          value: email,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value),
        },
        description: null,
        button: {
          title: 'Send password reset code',
          action: handleNextStep,
        },
      },
      [STEPS.VERIFY_EMAIL]: {
        title: 'Verify your e-mail',
        subtitle: 'Enter the verification code we sent you.',
        input: {
          label: 'Verification code',
          type: 'text',
          placeHolder: '',
          value: verifyCode,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => setVerifyCode(e.target.value),
        },
        description: null,
        button: {
          title: 'Continue',
          action: handleNextStep,
        },
      },
      [STEPS.NEW_PASSWORD]: {
        title: 'Create your new password',
        subtitle: 'Enter the verification code we sent you.',
        input: {
          label: 'Password',
          type: 'password',
          placeHolder: 'Password',
          footer: 'Use 8 or more characters with a combination of letters, numbers and symbols.',
          value: newPassword,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value),
        },
        description: null,
        button: {
          title: 'Redefine password',
          action: handleNextStep,
        },
      },
      [STEPS.FINISH]: {
        title: "You're all set!",
        subtitle: 'Your password has been reset.',
        input: null,
        description: 'For security, you will need it every time you access your account.',
        button: {
          title: 'Login',
          action: handleNextStep,
        },
      },
    };

    const currentStepValues = STEP_VALUES[step];

    return (
      <>
        <h1 className="title">{currentStepValues.title}</h1>
        <h2 className="subtitle">{currentStepValues.subtitle}</h2>
        <div className="step-content">
          {currentStepValues.input && <Input {...currentStepValues.input} className="main-input" />}
          {currentStepValues.description && (
            <p className="description">{currentStepValues.description}</p>
          )}

          {currentStepValues.button && (
            <Button className="main-button" onClick={handleNextStep}>
              {currentStepValues.button?.title}
            </Button>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="reset-password-container">
      <img src={ImersiveLogoDark} alt="Immersive finance" className="logo" />
      <div className="content">{renderStep()}</div>
    </div>
  );
}
